import { css } from "@emotion/react"
import { Button } from "component"
import { ChangeEventHandler, MouseEventHandler } from "react"
import { AiOutlineSearch } from "react-icons/ai"

type Props = {
  onInputChange : ChangeEventHandler<HTMLInputElement>
  onSearchButtonClick : MouseEventHandler<HTMLButtonElement>
}

export const SearchBar = (props: Props)=>{
  return(
    <>
      <div css={searchInputContainerCss}>
        <input css={dateSearchInputCss} type="date" min="2023-03-14" onChange={props.onInputChange}></input>
        <Button onClick={props.onSearchButtonClick}><AiOutlineSearch/></Button>
      </div>
    </>
  )
}

const searchInputContainerCss=css`
  padding: 1rem;
  display: flex;
  justify-content: center;
`

const dateSearchInputCss=css`
  padding: 0.5rem;
  flex-grow: 1;
  height: 2rem;
  border-width: 0;
  text-align: center;
  background-color: #eaeaea;
  margin-right: 1rem;
`